import "./App.css";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import Home from "./components/pages/Home";
import Navbar from "./components/Navbar";
import Portfolio from "./components/pages/Portfolio";
import AboutMe from "./components/pages/AboutMe";
import Contact from "./components/pages/Contact";
import Dis from "./components/pages/Dis";
import NetflixClone from "./components/pages/NetflixClone";
import SpotifyClone from "./components/pages/SpotifyClone";
import SlackClone from "./components/pages/SlackClone";
import TikTokClone from "./components/pages/TikTokClone";

function App() {
  return (
    <div className="App">
      <Router>
        <Switch>
          <Route path="/" exact component={Home} />
          <Route path="/portfolio" component={Portfolio} />
          <Route path="/about-me" component={AboutMe} />
          <Route path="/contact" component={Contact} />
          <Route path="/dis" component={Dis} />
          <Route path="/netflixclone" component={NetflixClone} />
          <Route path="/spotifyclone" component={SpotifyClone} />
          <Route path="/slackclone" component={SlackClone} />
          <Route path="/tiktokclone" component={TikTokClone} />
        </Switch>
      </Router>
    </div>
  );
}

export default App;
